import { TypeOfUberRideEnum } from './../../../../core/enums/uber.enum';
import { Component, Injector, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { CompaniesEnum, CompaniesList } from 'app/core/enums/companies.enum';
import { LyftService } from 'app/core/services/lyft.service';
import { UberService } from 'app/core/services/uber.service';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { ValidateTotalMilesLyft } from 'app/utils/helpers';
import { Subscription } from 'rxjs';
import { SweetAlertHelper } from '../../../../core/helpers/sweet-alert-helper.service';
import { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';

@Component({
  selector: 'app-button-send-provider',
  templateUrl: 'button-send-provider.component.html',
  styleUrls: ['./button-send-provider.component.scss'],
})

export class ButtonSendProviderComponent extends ParentModule implements OnInit, OnChanges, OnDestroy {
  subscriptions: Subscription[] = [];
  @Input() providerId: number;
  @Input() tripId: number;
  @Input() miles: number;
  @Input() dateOfService: Date;
  isSendTrip: boolean;
  disabledBtn: boolean;
  TypeOfUberRide: TypeOfUberRideEnum;

  constructor(
    private lyftService: LyftService,
    private uberService: UberService,
    private t2LoadingService: T2LoadingService,
    private sweetAlertHelper: SweetAlertHelper,
    protected Inject: Injector,
  ) {
    super('app-edit-reservation-form', Inject);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['providerId'], this.providerId)) {
      if (this.validateActionPermission) {
        this.verifySendSwitch();
      }
    }
  }

  ngOnInit() {
    this.observables();
  }

  observables(): void {
    this.subscriptions.push(
      this.actionsList$.subscribe(() => {
        if (this.validateActionPermission) {
          this.verifySendSwitch();
        }
      })
    );
  }

  verifySendUber(tripId: number) {
    if (tripId) {
      this.subscriptions.push(
        this.uberService.getIsSentToUber(tripId).subscribe(
          (resp: boolean) => {
            this.isSendTrip = resp;
          },
          (error) => {
            this.sweetAlertHelper.captureException(error);
          }
        )
      );
    }
  }

  verifySendLyft(tripId: number) {
    if (tripId) {
      this.subscriptions.push(
        this.lyftService.getIsSentToLyft(tripId).subscribe(
          (resp: boolean) => {
            this.isSendTrip = resp;
          },
          (error) => {
            this.sweetAlertHelper.captureException(error);
          }
        )
      );
    }
  }

  private verifySendSwitch() {
    switch (this.providerId) {
      case CompaniesEnum.Lyft:
        this.verifySendLyft(this.tripId);
        break;
      case CompaniesEnum.Uber:
        this.verifySendUber(this.tripId);
        break;
    }
  }

  verifyTotalMiles() {
    if (!this.tripId || !this.miles || !this.providerId) {
      return;
    }

    const dispatchAlertForMiles = ValidateTotalMilesLyft(this.miles);

    if (!dispatchAlertForMiles) {
      this.showSendProviderMessage(this.tripId);
      return;
    }

    this.showAlertForValidationMiles()
      .then(({ value }) => {
        if (value) {
          this.showSendProviderMessage(this.tripId);
        }
      });
  }

  private showAlertForValidationMiles(): Promise<SweetAlertResult> {
    const provider = this.providerInfo;
    return this.sweetAlertHelper.createCustomAlert({
      title: `${provider.description} 50 Miles`,
      html: `<div> <p>This trip is over 50 miles, do you want to send to ${provider.description}?</p><br> </div>`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#FF0000',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes',
    });
  }

  showSendProviderMessage(tripId: number) {
    const provider = this.providerInfo;
    const sweetAlertOptions = this.getSweetAlertConfigToSendTrip(provider.description);

    this.sweetAlertHelper.createCustomAlert(sweetAlertOptions)
      .then(({value}) => {
        if (value) {
          this.determinateWhatKindOfTimeSendToUber(value);
          this.sendProviderSwitch(tripId, provider.id);
        }
      });
  }

  sendToUber(tripId: number) {
    if (tripId) {
      this.t2LoadingService.show('Sending to Uber');
      this.subscriptions.push(
        this.uberService.sendToUber(tripId, { TypeOfUberRide: this.TypeOfUberRide }).subscribe(
          (resp) => {
            if (resp) {
              this.disabledBtn = false;
              this.t2LoadingService.hiden();
              this.sweetAlertHelper.createCustomAlert({
                title: 'Success!',
                text: resp.message,
                type: 'success',
              }).then(() => {
                this.verifySendSwitch();
              });
            }
          },
          (error) => {
            this.disabledBtn = false;
            this.t2LoadingService.hiden();
            this.sweetAlertHelper.captureException(error);
          }
        )
      );
    }
  }

  sendToLyft(tripId: number) {
    if (tripId) {
      this.t2LoadingService.show('Sending to lyft');
      this.subscriptions.push(
        this.lyftService.sendToLyft(tripId).subscribe(
          () => {
            this.disabledBtn = false;
            this.t2LoadingService.hiden();
            this.sweetAlertHelper.createCustomAlert({
              title: 'Success!',
              text: 'Sent To Lyft Successfully',
              type: 'success',
            }).then(() => {
              this.verifySendSwitch();
            });
          },
          (error) => {
            this.disabledBtn = false;
            this.t2LoadingService.hiden();
            this.sweetAlertHelper.captureException(error);
          }
        )
      );
    }
  }

  cancelSend() {
    const provider = this.providerInfo;
    this.sweetAlertHelper.createCustomAlert({
      title: 'Cancellation',
      text: `Are you sure to cancel the trip to ${provider.description}?`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Accept',
    }).then((result: any) => {
      if (result.value) {
        this.cancellationSwitch(provider.id, this.tripId);
      }
    });
  }

  sendProviderSwitch(tripId: number, providerId: number) {
    if (tripId && providerId) {
      this.disabledBtn = true;
      switch (providerId) {
        case CompaniesEnum.Lyft:
          this.sendToLyft(tripId);
          break;
        case CompaniesEnum.Uber:
          this.sendToUber(tripId);
          break;
      }
    }
  }

  cancellationSwitch(providerId: number, tripId: number) {
    if (providerId && tripId) {
      switch (providerId) {
        case CompaniesEnum.Lyft:
          this.cancelSendLyft(tripId);
          break;
        case CompaniesEnum.Uber:
          this.cancelSendUber(tripId);
          break;
      }
    }
  }

  cancelSendLyft(tripId: number) {
    if (tripId) {
      this.lyftService.cancelSendToLyft(tripId).subscribe(
        () => {
          this.sweetAlertHelper.createCustomAlert({
            title: 'success!',
            text: 'Successfully Cancellation',
            type: 'success',
          }).then(() => {
            this.verifySendSwitch();
          });
        },
        (error) => {
          this.sweetAlertHelper.captureException(error);
        }
      );
      this.subscriptions.push();
    }
  }

  cancelSendUber(tripId: number) {
    if (tripId) {
      this.uberService.cancelSendToUber(tripId).subscribe(
        () => {
          this.sweetAlertHelper.createCustomAlert({
            title: 'Success!',
            text: 'Successfully Cancellation',
            type: 'success',
          }).then(() => {
            this.verifySendSwitch();
          });
        },
        (error) => {
          this.sweetAlertHelper.captureException(error);
        }
      );
    }
  }

  private getSweetAlertConfigToSendTrip(provider: string): SweetAlertOptions {
    const message = this.showInputRadioToSendUberTrip
      ? `Do you want to schedule this trip as a flexible ride, allowing the rider to request it via text message when they’re ready?`
      : `Are you sure to send the trip to ${provider}?`;

    const generalOptions: SweetAlertOptions = {
      title: `Send to ${provider}`,
      text: message,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Accept',
    };

const uberOptions: SweetAlertOptions = {
  width: '34em',
  customClass: 'swal2-uber-ride-options',
  input: 'radio',
  inputOptions: {
    [String(TypeOfUberRideEnum.Normal)]: 'Send the Trip Now',
    [String(TypeOfUberRideEnum.Flexible)]: 'Schedule a Flexible Ride',
  },
  inputValue: String(TypeOfUberRideEnum.Normal)
};

    return this.showInputRadioToSendUberTrip ? Object.assign({}, generalOptions, uberOptions) : generalOptions;
  }

  private determinateWhatKindOfTimeSendToUber(sweetAlertResult: string | boolean): void {
    this.TypeOfUberRide = typeof sweetAlertResult === 'string'
      ? Number(sweetAlertResult) as TypeOfUberRideEnum
      : TypeOfUberRideEnum.Normal;
  }

  get providerInfo() {
    return CompaniesList.find(item => item.id === this.providerId);
  }

  get imageUrl(): string {
    const provider = this.providerInfo;
    return provider ? provider.url : null;
  }

  get validateActionPermission(): boolean {
    return (this.isAllowedAction('Send To Lyft') && this.providerId === CompaniesEnum.Lyft)
      || (this.isAllowedAction('SendToUber') && this.providerId === CompaniesEnum.Uber);
  }

  get showInputRadioToSendUberTrip(): boolean {
    return this.providerId === CompaniesEnum.Uber;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/edit-reservation/button-send-provider/button-send-provider.component.ts